/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/jsx-closing-bracket-location */

import ReactGA from 'react-ga';
import Session from '../Service/Session';

export const initGA = () => {
  
  // load user details
  const currentUser = Session.get("CURRENT_USER_INFO");
  let userId = null;
  if(currentUser){
    userId = currentUser.attributes.preferred_username || currentUser.attributes.sub;
  }

  // Google analytics tracker
  ReactGA.initialize('UA-154154797-1', {
    debug: false,
    gaOptions: {
      userId: userId
    }
  });

  // push campaign source if exists
  let campaign = Session.get("campaign");
  if(campaign){
    campaign = campaign.utm_campaign || "none";
    ReactGA.set({ campaignSource: campaign });
  }

}

export const logPageView = (loc) => {

  if(!window.gaData) { initGA(); }

  // we may want to receive a path
  // window.location.pathname returns / when no urls are used
  loc = loc || window.location.pathname;
  //ReactGA.set({ page: loc });
  // log page view
  ReactGA.pageview(loc);

}

export const logEvent = (category = '', action = '') => {
  if (category && action) {
    ReactGA.event({ category, action });
  }
}

export const logException = (description = '', fatal = false) => {
  if (description) {
    ReactGA.exception({ description, fatal });
  }
}